import { defineStore } from 'pinia'
import api from '@/utils/api'

export const useWebinarStore = defineStore('webinar', {
  state: () => ({
    webinars: [],
    loading: false,
    error: null,
    lastFetched: null
  }),
  getters: {
    activeWebinars: (state) => {
      return state.webinars.filter(webinar => webinar.is_active !== false)
    },
    needsRefresh: (state) => {
      // Refresh data if it's older than 30 minutes or if no data exists
      if (!state.lastFetched) return true
      const thirtyMinutesAgo = Date.now() - (30 * 60 * 1000)
      return state.lastFetched < thirtyMinutesAgo
    }
  },
  actions: {
    setWebinars(data) {
      this.webinars = data || []
    },
    setLoading(loading) {
      this.loading = loading
    },
    setError(error) {
      this.error = error
    },
    async fetchWebinars(force = false) {
      // Don't fetch if already loading
      if (this.loading && !force) return
      
      // Don't fetch if data is fresh and not forcing
      if (!this.needsRefresh && !force && this.webinars.length > 0) return
      
      this.setLoading(true)
      this.setError(null)
      
      try {
        const data = await api.get('/webinars')
        
        // Transform API data to match expected format
        const transformedData = Array.isArray(data) ? data.map(webinar => ({
          id: webinar.id,
          name: webinar.name || webinar.title,
          title: webinar.name || webinar.title,
          video_link: webinar.video_link || webinar.video,
          video: webinar.video_link || webinar.video,
          thumbnail: webinar.thumbnail || webinar.image,
          image: webinar.thumbnail || webinar.image,
          duration: webinar.duration || '45 min',
          is_active: webinar.is_active !== false
        })) : []
        
        this.setWebinars(transformedData)
        this.lastFetched = Date.now()
      } catch (error) {
        this.setError(error.message || 'Failed to fetch webinars')
        
        // Provide fallback data if API fails
        if (this.webinars.length === 0) {
          this.setWebinars(this.getMockWebinars())
        }
      } finally {
        this.setLoading(false)
      }
    },
    getMockWebinars() {
      return [
        {
          id: 1,
          title: 'Franchise Success Stories: 2024 Panel',
          thumbnail: 'https://img.youtube.com/vi/3JZ_D3ELwOQ/hqdefault.jpg',
          video: 'https://www.youtube.com/watch?v=3JZ_D3ELwOQ',
          duration: '55 min'
        },
        {
          id: 2,
          title: 'Digital Marketing for Franchises',
          thumbnail: 'https://img.youtube.com/vi/2vjPBrBU-TM/hqdefault.jpg',
          video: 'https://www.youtube.com/watch?v=2vjPBrBU-TM',
          duration: '40 min'
        },
        {
          id: 3,
          title: 'Women Leaders in Franchising',
          thumbnail: 'https://i.vimeocdn.com/video/703876203_640.jpg',
          video: 'https://vimeo.com/76979871',
          duration: '35 min'
        },
        {
          id: 4,
          title: 'Franchise Legal Essentials',
          thumbnail: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=400&q=80',
          video: 'https://www.example.com/videos/legal-essentials.mp4',
          duration: '50 min'
        },
        {
          id: 5,
          title: 'Financing Your Franchise Dream',
          thumbnail: 'https://img.youtube.com/vi/9bZkp7q19f0/hqdefault.jpg',
          video: 'https://www.youtube.com/watch?v=9bZkp7q19f0',
          duration: '60 min'
        },
        {
          id: 6,
          title: 'Customer Experience Mastery',
          thumbnail: 'https://img.youtube.com/vi/8jLoqVcJjT8/hqdefault.jpg',
          video: 'https://www.youtube.com/watch?v=8jLoqVcJjT8',
          duration: '45 min'
        }
      ]
    }
  }
}) 
